import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/router-devtools';
import type { QueryClient } from '@tanstack/react-query';
import { Sidebar } from '@/components/layout/Sidebar';
import { TopBar } from '@/components/layout/TopBar';
import { SidebarProvider } from '@/components/layout/sidebar-context';

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: RootLayout,
});

function RootLayout() {
  return (
    <SidebarProvider>
      <div className="min-h-screen flex bg-background text-foreground">
        <Sidebar />
        <div className="flex-1 flex flex-col min-w-0 bg-background">
          <TopBar />
          <main className="flex-1 w-full min-w-0 px-3.5 sm:px-5 lg:px-8 pt-5 md:pt-6 pb-24 md:pb-8">
            <div className="mx-auto w-full max-w-[1040px]">
              <Outlet />
            </div>
          </main>
        </div>
        {import.meta.env.DEV && <TanStackRouterDevtools position="bottom-right" />}
      </div>
    </SidebarProvider>
  );
}
